import Hero from '@components/sections/Hero'
import SEO from '@components/common/SEO'

const Home = () => {
  return (
    <>
      <SEO path="/" />
      <Hero />
    </>
  )
}

export default Home
